// extracted by mini-css-extract-plugin
module.exports = {"root":"ConsentHeader_root__37OKX","name":"ConsentHeader_name__wdwY6","birthday":"ConsentHeader_birthday__3Sknw","skeleton":"ConsentHeader_skeleton__3RZbU"};